import {CHANGE_KRW, CHANGE_IMAGE, FETCH_KRW_DATA_SUCCESS, FETCH_KRW_DATA_ERROR, CHANGE_DATA} from "../actions/types";
import initialState from './initialState';
import {calculateCodeValue} from '../utils/helpers';

export default (prevState = initialState.KRW, action) => {
    switch (action.type) {

        case FETCH_KRW_DATA_SUCCESS:
            return {...prevState, ...action.payload};

        case FETCH_KRW_DATA_ERROR:
            return prevState;

        case CHANGE_DATA:
            const {name, value, articleName, articleID} = action.payload;
            if (articleName === 'KRW') {
                let newState = {...prevState};
                // update value of input field
                if (Object.prototype.toString.call(name) === '[object Object]') {
                    for (const prop in name) {
                        newState[prop].CurrentValue = name[prop];
                    }
                } else {
                    newState[name].CurrentValue = value;
                }

                if (!newState.articleID) {
                    newState.articleID = articleID;
                }

                // calculate Sichtkanten-Code value on the step 2
                newState.SIK.CurrentValue = calculateCodeValue(newState, 'krw', ['SK23', 'SK45', 'SK67', 'SK81']);

                return newState;
            } else {
                return prevState;
            }
        case CHANGE_IMAGE:
            if (action.name === 'krw') {
                const state = {...prevState};
                state["image"] = action.payload;
                return state;
            }
            return prevState;
        default:
            return prevState;

    }
}






// WEBPACK FOOTER //
// ./src/reducers/krwReducer.js